<!--
 * @Author: hl
 * @Date: 2023-03-18 15:29:12
 * @LastEditors: lh
 * @LastEditTime: 2023-06-09 14:34:28
-->
<template>
  <div class="nodata">
    <img src="../../../static/img/com_invitteFriend/no_date.png" alt="" />
    <div class="text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  props:{
    text:{
      type:String,
      default:'这里现在空空如也，等一下再过来吧'
    }
  }
};
</script>

<style lang="scss" scoped>
.nodata {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  img {
    height: 40vh;
    width: 40vh;
  }
  .text {
    font-size: 3.2vh;
    font-weight: 400;
    color: #de9759;
    margin-top: 3.733333vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hor_redbag/common/no_data.vue